import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Film, Camera, Users, Mail, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ videos: 0, photos: 0, onboarding: 0, contacts: 0 });

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const CARDS = [
    { k: "videos", label: "Video Reels", icon: Film, to: "/admin/media" },
    { k: "photos", label: "Photo Stills", icon: Camera, to: "/admin/media" },
    { k: "onboarding", label: "Onboarding", icon: Users, to: "/admin/onboarding" },
    { k: "contacts", label: "Inquiries", icon: Mail, to: "/admin/contacts" },
  ];

  return (
    <div className="p-8 lg:p-12" data-testid="admin-dashboard">
      <div className="flex items-baseline justify-between mb-12">
        <div>
          <div className="font-mono text-[10px] tracking-[0.4em] text-neutral-500 mb-2">CONTROL ROOM</div>
          <h1 className="font-bodoni text-5xl md:text-7xl">Dashboard.</h1>
        </div>
        <div className="hidden md:block font-mono text-[10px] text-neutral-500 tracking-widest">
          SIGNAL: STABLE
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-900">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <Link
              key={c.k}
              to={c.to}
              data-testid={`stat-${c.k}`}
              className="bg-black p-8 hover:bg-neutral-950 transition-colors group min-h-[180px] flex flex-col justify-between"
            >
              <div className="flex items-start justify-between">
                <Icon size={18} className="text-neutral-600 group-hover:text-white transition-colors" />
                <ArrowUpRight size={14} className="text-neutral-700 group-hover:text-white transition-colors" />
              </div>
              <div>
                <div className="font-bodoni text-6xl">{stats[c.k]}</div>
                <div className="font-mono text-[10px] text-neutral-500 tracking-widest mt-2">{c.label.toUpperCase()}</div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-px bg-neutral-900">
        <div className="bg-black p-8">
          <div className="font-mono text-[10px] text-neutral-500 tracking-widest mb-4">QUICK ACTIONS</div>
          <div className="space-y-2">
            <Link to="/admin/media" className="block p-4 border border-neutral-900 hover:border-white transition-colors">
              <div className="font-bodoni text-xl">Upload New Reel</div>
              <div className="font-mono text-xs text-neutral-500">Add a video to the public portfolio</div>
            </Link>
            <Link to="/admin/media" className="block p-4 border border-neutral-900 hover:border-white transition-colors">
              <div className="font-bodoni text-xl">Upload Still</div>
              <div className="font-mono text-xs text-neutral-500">Add a photograph to the gallery</div>
            </Link>
          </div>
        </div>
        <div className="bg-black p-8">
          <div className="font-mono text-[10px] text-neutral-500 tracking-widest mb-4">FAMILY MOTTO</div>
          <p className="font-bodoni text-3xl italic leading-tight">
            "From chaos to balance & flow. The good times roll forever."
          </p>
          <div className="font-mono text-[10px] text-neutral-700 mt-6 tracking-widest">
            JOINT OSS · 4EVER ROLLIN'
          </div>
        </div>
      </div>
    </div>
  );
}
